import { getReferrer } from '@/shared/features/enter-referrer-tracking';
import { UNKNOWN_BUILD_ENTRY_POINT } from '@/shared/quiz/events.quiz-build';

/**
 * 이번 빌드 화면을 **어느 진입점(CTA)으로 열었는지**. 진입 때 한 번 잡아 저장까지 들고 간다.
 *
 * 진입 기록(`getReferrer`)은 `enter_build` 를 쏜 직후 `SafeEnterTracking` 이 지운다.
 * 그런데 저장은 한참 뒤라, 저장 시점에 다시 읽으면 **언제나 비어 있다** — 실제로
 * `build_entry_point` 이 전부 `unknown` 으로 기록됐다(dev-3 실측, 리뷰 지적).
 *
 * 그래서 지우기 전에 여기로 옮겨 둔다. 모듈 스코프라 페이지를 새로 열면 초기화되고,
 * 빌드 화면에 들어올 때마다 덮어써서 이전 세션 값이 남지 않는다.
 */
let buildEntryPoint = UNKNOWN_BUILD_ENTRY_POINT;

/** 빌드 화면 진입 때 호출한다. `clearReferrer` 보다 **먼저** 불러야 한다. */
export const captureBuildEntryPoint = () => {
  const referrer = getReferrer();
  // 진입점마다 어디에 적는지가 다르다 — 버튼 식별자를 `location` 에 남기는 곳도 있고
  // (`play_jelly_copy_guide`), 경로만 `from` 에 남기는 곳도 있다(`CreateButton`).
  // 하나만 보면 나머지가 통째로 `unknown` 이 된다(리뷰 지적).
  buildEntryPoint =
    referrer?.location ?? referrer?.from ?? UNKNOWN_BUILD_ENTRY_POINT;
};

/** 저장 이벤트가 읽는다. 진입을 못 잡았으면 `unknown`. */
export const getBuildEntryPoint = () => buildEntryPoint;
